export default __webpack_public_path__ + "static/media/jack.60d2ea2a.gif";